import "core-js/modules/es.array.concat.js";
export function generateUtmUrl(params) {
  var baseUrl = params.baseUrl,
      source = params.source,
      medium = params.medium,
      campaign = params.campaign;
  if (!baseUrl) return '';
  return "".concat(baseUrl, "?utm_source=").concat(source, "&utm_medium=").concat(medium, "&utm_campaign=").concat(campaign);
}